<template>
  <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane label="保险服务" name="ensure">
      <EnsuranceService v-if="load.ensure"></EnsuranceService>
    </el-tab-pane>
    <el-tab-pane label="金融服务" name="fina">
      <FinianceService v-if="load.fina"></FinianceService>
    </el-tab-pane>
    <el-tab-pane label="病例抽取服务" name="ent">
      <EntityService v-if="load.ent"></EntityService>
    </el-tab-pane>
    <el-tab-pane label="相似病例匹配" name="sim">
      <MedicalSimService v-if="load.sim"></MedicalSimService>
    </el-tab-pane>
    <el-tab-pane label="用户患病预测" name="ud">
      <UserDiseasePredict v-if="load.ud"></UserDiseasePredict>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import FinianceService from "@/views/out_service/FinianceService.vue";
import EnsuranceService from "@/views/out_service/EnsuranceService.vue";
import EntityService from "@/views/out_service/EntityService.vue";
import MedicalSimService from "@/views/out_service/MedicalSimService.vue";
import UserDiseasePredict from "@/views/out_service/UserDiseasePredict.vue";


export default {
  name: "ServiceView",
  components: {
    FinianceService,
    EnsuranceService,
    EntityService,
    MedicalSimService,
    UserDiseasePredict,
  },
  data() {
    return {
      activeName: 'ensure',
      load: {
        ensure: true,
        fina: false,
        ent: false,
        sim: false,
        ud: false,
      }
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(event)
      if (this.load[tab.name] === false) {
        this.load[tab.name] = true
      }
    }
  }
}
</script>

<style scoped>

</style>
